
<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <strong>Add match</strong>
                    </div>
                    <b-form>
                        <b-form-group
                            label="LocalTeam"
                            label-for="localTeamSelect"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-select
                                id="localTeamSelect"
                                :plain="true"
                                :options="teamsNamesArray"
                                value="Select local team..."
                                v-model="currentLocalTeam"
                                v-on:change="setLocalTeam"
                            ></b-form-select>
                            <b-form-input
                                v-if="isEdit"
                                id="localTeamScore"
                                type="text"
                                autocomplete="name"
                                v-model="matchData.localTeam.score"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Away Team Name"
                            label-for="awayTeamName"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-input
                                id="awayTeamName"
                                type="text"
                                autocomplete="name"
                                v-model="matchData.awayTeam.name"
                            ></b-form-input>
                            <b-form-input
                                v-if="isEdit"
                                id="awayTeamScore"
                                type="text"
                                autocomplete="name"
                                v-model="matchData.awayTeam.score"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            validated
                            label="Date"
                            label-for="date"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-input type="date" required id="date" v-model="matchData.date"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            validated
                            label="Hour"
                            label-for="hour"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-input type="time" required id="hour" v-model="matchData.hour"></b-form-input>
                        </b-form-group>
                        <b-form-group
                            validated
                            label="Duration (minutes)"
                            label-for="duration"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-input
                                type="number"
                                required
                                id="duration"
                                v-model="matchData.duration"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            validated
                            label="Location"
                            label-for="location"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <gmap-autocomplete
                                style="width:100%; height:100%"
                                placeholder="Match location..."
                                @place_changed="setPlaceLocation"
                            ></gmap-autocomplete>
                        </b-form-group>
                        <b-form-group
                            v-if="marker != null"
                            label="Extra information"
                            label-for="extraInformation"
                            :label-cols="3"
                            :horizontal="true"
                        >
                            <b-form-input
                                type="text"
                                required
                                id="extraInformation"
                                v-model="matchData.location.information"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group v-if="marker != null">
                            <gmap-map
                                :center="center"
                                :zoom="15"
                                style="width:100%;  height: 400px;"
                            >
                                <gmap-marker v-model="marker" :position="marker"></gmap-marker>
                            </gmap-map>
                        </b-form-group>
                        <div slot="footer">
                            <b-row class="align-items-center">
                                <b-col xl="2" class="mb-3 mb-xl-0">
                                    <b-button v-on:click="goBack" block variant="secondary">Back</b-button>
                                </b-col>
                                <b-col xl="6" class="mb-3 mb-xl-0">
                                    <b-button
                                        type="submit"
                                        v-if="!isEdit"
                                        v-on:click="confirmMatchButton"
                                        block
                                        variant="primary"
                                    >
                                        <i class="fa fa-dot-circle-o"></i> Confirm Match
                                    </b-button>
                                    <b-button
                                        type="submit"
                                        v-if="isEdit"
                                        v-on:click="updateMatch"
                                        block
                                        variant="primary"
                                    >
                                        <i class="fa fa-dot-circle-o"></i> Save Changes
                                    </b-button>
                                </b-col>
                                <b-col xl="4" class="mb-3 mb-xl-0">
                                    <b-button
                                        v-if="isEdit"
                                        v-on:click="removeMatch"
                                        block
                                        variant="danger"
                                    >
                                        <i class="fa fa-ban"></i> Remove Match
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <!-- ******************* -->
        <!--     Attachments      -->
        <!-- ******************* -->
        <b-row>
            <b-col xs="12" md="4" xl="4" v-if="isEdit">
                <image-attachment
                    :type="type"
                    :typeId="matchData.key"
                    :teamId="matchData.localTeamKey"
                ></image-attachment>
            </b-col>
            <b-col xs="12" md="4" xl="4" v-if="isEdit">
                <video-attachment
                    :type="type"
                    :typeId="matchData.key"
                    :teamId="matchData.localTeamKey"
                ></video-attachment>
            </b-col>
            <b-col xs="12" md="4" xl="4" v-if="isEdit">
                <file-attachment
                    :type="type"
                    :typeId="matchData.key"
                    :teamId="matchData.localTeamKey"
                ></file-attachment>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from "underscore";
import { db } from "@/config/devowqlo";
import { storage } from "@/config/devowqlo";
import { auth } from "@/config/devowqlo";
import { functions } from "@/config/devowqlo";
import imageAttachment from "@/views/attachments/ImageAttachment";
import videoAttachment from "@/views/attachments/VideoAttachment";
import fileAttachment from "@/views/attachments/FileAttachment";
export default {
    components: {
        imageAttachment: imageAttachment,
        videoAttachment: videoAttachment,
        fileAttachment: fileAttachment
    },
    name: "forms",
    firebase: {
        teams: db.ref("teams"),
        matches: db.ref("teamMatches"),
        categories: db.ref("categories"),
        counts: db.ref("counts")
    },
    data() {
        return {
            type: "match",
            isEdit: false,
            currentLocalTeam: null,
            matchData: {
                key: null,
                date: null,
                hour: null,
                duration: null,
                localTeamKey: null,
                localTeam: {
                    name: null,
                    logoUrl: null,
                    thumbLogoUrl: null,
                    category: null,
                    score: 0
                },
                awayTeam: {
                    name: null,
                    score: 0
                },
                location: {
                    name: null,
                    information: null,
                    latitude: null,
                    longitude: null
                }
            },
            center: null,
            marker: null,
            teamsArray: [],
            teamsNamesArray: []
        };
    },
    created() {
        if (this.$route.params.info) {
            const infoString = String(this.$route.params.info);
            const infoSplit = infoString.split("&&");

            this.matchData.key = infoSplit[0];
            this.matchData.localTeamKey = infoSplit[1];
            this.setMatch();
        }

        db.ref("teams").once("value", snapshot => {
            this.teamsNamesArray = [];
            this.teamsArray = [];
            snapshot.forEach(categorySnapshot => {
                categorySnapshot.forEach(teamSnapshot => {
                    console.log(teamSnapshot.val());
                    this.teamsNamesArray.push(
                        teamSnapshot.val().name +
                            " · " +
                            this.getCategoryName(teamSnapshot.val().category)
                    );
                    this.teamsArray.push(teamSnapshot);

                    if (teamSnapshot.key == this.matchData.localTeamKey) {
                        this.currentLocalTeam =
                            teamSnapshot.val().name +
                            " · " +
                            this.getCategoryName(teamSnapshot.val().category);
                    }
                });
            });
        });
    },
    methods: {
        setPlaceLocation(place) {
            console.log(place);
            //Set match info
            this.matchData.location = {
                name: place.formatted_address,
                latitude: place.geometry.location.lat(),
                longitude: place.geometry.location.lng()
            };

            //Add marker to map
            this.marker = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            };
            this.center = this.marker;
        },
        goBack() {
            this.$router.go(-1);
            // this.$router.replace({path: '/users'})
        },
        setMatch() {
            this.isEdit = true;
            this.$firebaseRefs.matches
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .once("value", snap => {
                    console.log(snap);
                    console.log(Object.values(snap.val().localTeam)[0].score);
                    this.matchData.localTeam.name = Object.values(
                        snap.val().localTeam
                    )[0].name;
                    this.matchData.localTeam.category = Object.values(
                        snap.val().localTeam
                    )[0].category;
                    this.matchData.localTeam.logoUrl = Object.values(
                        snap.val().localTeam
                    )[0].logoUrl;
                    this.matchData.localTeam.thumbLogoUrl = Object.values(
                        snap.val().localTeam
                    )[0].thumbLogoUrl;
                    this.matchData.localTeam.score = Object.values(
                        snap.val().localTeam
                    )[0].score;

                    this.matchData.awayTeam.name = snap.val().awayTeam.name;
                    this.matchData.awayTeam.score = snap.val().awayTeam.score;
                    this.matchData.date = snap.val().date;
                    this.matchData.hour = snap.val().hour;
                    this.matchData.duration = snap.val().duration;
                    this.matchData.location = snap.val().location;

                    this.marker = {
                        lat: snap.val().location.latitude,
                        lng: snap.val().location.longitude
                    };
                    this.center = this.marker;
                });
        },
        removeMatch() {},
        updateMatch() {
            const dateNow = Date.now();
            var matchModel = {
                timeStamp: new Date(
                    this.matchData.date + " " + this.matchData.hour
                ).getTime(),
                date: this.matchData.date,
                hour: this.matchData.hour,
                duration: this.matchData.duration,
                awayTeam: this.matchData.awayTeam,
                location: this.matchData.location,
                modified: dateNow
            };

            this.$firebaseRefs.matches
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .update(matchModel);
            this.$firebaseRefs.matches
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .child("localTeam")
                .child(this.matchData.localTeamKey)
                .set(this.matchData.localTeam);

            db.ref("categoryMatches")
                .child(this.matchData.localTeam.category)
                .child(this.matchData.key)
                .update(matchModel);
            db.ref("categoryMatches")
                .child(this.matchData.localTeam.category)
                .child(this.matchData.key)
                .child("localTeam")
                .child(this.matchData.localTeamKey)
                .set(this.matchData.localTeam);

            var notificationModel = {
                type: "match",
                typeId: this.matchData.key,
                typeName:
                    this.matchData.localTeam.name +
                    " VS " +
                    this.matchData.awayTeam.name,
                action: "modified",
                timestamp: dateNow,
                 viewed: false 
            };
            // NEW!!
            db.ref("matchControl")
                .child("viewControl")
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .child("pending")
                .set(null);
            db.ref("matchControl")
                .child("viewControl")
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .child("seen")
                .set(null);
            db.ref("matchControl")
                .child("availabilityControl")
                .child(this.matchData.localTeamKey)
                .child(this.matchData.key)
                .child("noAvailbale")
                .set(null);

            db.ref("teamMembers")
                .child(this.matchData.localTeamKey)
                .child("members")
                .once("value", snapshot => {
                    snapshot.forEach(childSnapshot => {
                        var notificationKey = db
                            .ref("userNotifications")
                            .child(childSnapshot.key)
                            .child("notifications")
                            .push(notificationModel).key;
                        db.ref("userNotifications")
                            .child(childSnapshot.key)
                            .child("notifications")
                            .child(notificationKey)
                            .child("team")
                            .child(this.matchData.localTeamKey)
                            .set(this.matchData.localTeam);
                        db.ref("userPending")
                            .child(childSnapshot.key)
                            .child("pendingMatches")
                            .child(this.matchData.key)
                            .set(true);

                        var userSimpleModel = {
                            name: childSnapshot.val().name,
                            lastName: childSnapshot.val().lastName
                        };
                        // NEW!!
                        if (childSnapshot.child("role").val() == "player") {
                            db.ref("matchControl")
                                .child("viewControl")
                                .child(this.matchData.localTeamKey)
                                .child(this.matchData.key)
                                .child("pending")
                                .child(childSnapshot.key)
                                .set(userSimpleModel);
                            db.ref("matchControl")
                                .child("availabilityControl")
                                .child(this.matchData.localTeamKey)
                                .child(this.matchData.key)
                                .child("available")
                                .child(childSnapshot.key)
                                .set(userSimpleModel);
                        }
                    });
                });

            this.$router.go(-1);
        },

        getCategoryName(categoryId) {
            var foundCategory = this.categories.find(
                category => category[".key"] === categoryId
            );
            if (foundCategory) {
                return foundCategory.name;
            } else {
                return "";
            }
        },
        getTeams(teams) {
            // var teamsNamesArray = []
            // this.teamsArray = []
            // db.ref('teams').once('value', (snapshot) =>{
            //       this.teamsArray = []
            //       snapshot.forEach(categorySnapshot => {
            //         categorySnapshot.forEach(teamSnapshot => {
            //           console.log(teamSnapshot.val())
            //           teamsNamesArray.push(teamSnapshot.val().name + ' · ' + this.getCategoryName(teamSnapshot.val().category))
            //           this.teamsArray.push(teamSnapshot)
            //         })
            //       })
            //     })
            // return teamsNamesArray
            // teams.forEach(categorySnap => {
            //   categorySnap.forEach(element => {
            //     teamsNamesArray.push(element.name + ' · ' + this.getCategoryName(element.category))
            //     teamsArray.push(element)
            //     if(element['.key'] == this.matchData.localTeamKey){
            //       this.currentLocalTeam = element.name + ' · ' + this.getCategoryName(element.category)
            //     }
            //   })
            // });
            // this.teamsArray = teamsArray
        },
        setLocalTeam(value) {
            var teamName = value.split(" · ")[0];
            this.teamsArray.forEach(element => {
                if (element.val().name == teamName) {
                    this.matchData.localTeamKey = element.key;
                    this.matchData.localTeam.name = element.val().name;
                    this.matchData.localTeam.logoUrl = element.val().logoUrl;
                    this.matchData.localTeam.thumbLogoUrl = element.val().thumbLogoUrl;
                    this.matchData.localTeam.category = element.val().category;
                }
            });
        },
        confirmMatchButton() {
            this.addMatch();
        },
        addMatch() {
            this.createMatchDb();
        },
        createMatchDb() {
            console.log("Creating match on DB...");
            const dateNow = Date.now();

            var matchModel = {
                timeStamp: new Date(
                    this.matchData.date + " " + this.matchData.hour
                ).getTime(),
                date: this.matchData.date,
                hour: this.matchData.hour,
                duration: this.matchData.duration,
                awayTeam: this.matchData.awayTeam,
                location: this.matchData.location,
                created: dateNow,
                modified: dateNow
            };

            var matchKey = db
                .ref("categoryMatches")
                .child(this.matchData.localTeam.category)
                .push(matchModel).key;
            db.ref("categoryMatches")
                .child(this.matchData.localTeam.category)
                .child(matchKey)
                .child("localTeam")
                .child(this.matchData.localTeamKey)
                .set(this.matchData.localTeam);
            this.$firebaseRefs.matches
                .child(this.matchData.localTeamKey)
                .child(matchKey)
                .set(matchModel);
            this.$firebaseRefs.matches
                .child(this.matchData.localTeamKey)
                .child(matchKey)
                .child("localTeam")
                .child(this.matchData.localTeamKey)
                .set(this.matchData.localTeam);
            db.ref("users/admins")
                .child(auth.currentUser.uid)
                .once("value", snapshot => {
                    var createdByModel = {
                        name: snapshot.val().name,
                        lastName: snapshot.val().lastName
                    };

                    //Created by
                    db.ref("teamMatches")
                        .child(this.matchData.localTeamKey)
                        .child(matchKey)
                        .child("createdBy")
                        .child(auth.currentUser.uid)
                        .set(createdByModel);
                    db.ref("categoryMatches")
                        .child(this.matchData.localTeam.category)
                        .child(matchKey)
                        .child("createdBy")
                        .child(auth.currentUser.uid)
                        .set(createdByModel);

                    //Modified by
                    db.ref("teamMatches")
                        .child(this.matchData.localTeamKey)
                        .child(matchKey)
                        .child("modifiedBy")
                        .child(auth.currentUser.uid)
                        .set(createdByModel);
                    db.ref("categoryMatches")
                        .child(this.matchData.localTeam.category)
                        .child(matchKey)
                        .child("modifiedBy")
                        .child(auth.currentUser.uid)
                        .set(createdByModel);
                });

            var notificationModel = {
                type: "match",
                typeId: matchKey,
                typeName:
                    this.matchData.localTeam.name +
                    " VS " +
                    this.matchData.awayTeam.name,
                action: "created",
                timestamp: dateNow
            };
            // NEW!!
            db.ref("teamMembers")
                .child(this.matchData.localTeamKey)
                .child("members")
                .once("value", snapshot => {
                    snapshot.forEach(childSnapshot => {
                        var notificationKey = db
                            .ref("userNotifications")
                            .child(childSnapshot.key)
                            .child("notifications")
                            .push(notificationModel).key;
                        db.ref("userNotifications")
                            .child(childSnapshot.key)
                            .child("notifications")
                            .child(notificationKey)
                            .child("team")
                            .child(this.matchData.localTeamKey)
                            .set(this.matchData.localTeam);
                        db.ref("userPending")
                            .child(childSnapshot.key)
                            .child("pendingMatches")
                            .child(matchKey)
                            .set(true);

                        var userSimpleModel = {
                            name: childSnapshot.val().name,
                            lastName: childSnapshot.val().lastName,
                            thumbPictureUrl: childSnapshot.val().thumbPictureUrl
                        };
                        // NEW!!
                        if (childSnapshot.child("role").val() == "player") {
                            db.ref("matchControl")
                                .child("viewControl")
                                .child(this.matchData.localTeamKey)
                                .child(matchKey)
                                .child("pending")
                                .child(childSnapshot.key)
                                .set(userSimpleModel);
                            db.ref("matchControl")
                                .child("availabilityControl")
                                .child(this.matchData.localTeamKey)
                                .child(matchKey)
                                .child("available")
                                .child(childSnapshot.key)
                                .set(userSimpleModel);
                        }
                    });
                });

            var countRef = this.$firebaseRefs.counts
                .child("matchesCount")
                .child("count");

            countRef.transaction(function(count) {
                if (count) {
                    count = count + 1;
                } else {
                    count = 1;
                }
                return count;
            });

            this.$router.go(-1);
        }
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// getAge(birthdate) {
    //   var today = new Date();
    //   var birthDate = new Date(birthdate);
    //   var age = today.getFullYear() - birthDate.getFullYear();
    //   var m = today.getMonth() - birthDate.getMonth();
    //   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //       age--;
    //   }    
    //   return age;
    // }
    // console.log(this.newUser.birthdate)
      // const timestamp = new Date(this.newUser.birthdate).getTime()
      // console.log(timestamp)
      // const dateFromTimestamp = new Date(timestamp)
      // console.log(dateFromTimestamp)

      // if(this.$route.params.teamid != null){
      //   console.log(this.$route.params.teamid)
      // }else{
      //   console.log("No hay id equipo")
      // }

      // Get a key for a new User.
      // var newUserKey = this.$firebaseRefs.users.push().key;

      // this.$firebaseRefs.users.child(newUserKey).set({
      //    name: this.userName,
      //    team: this.teamSelect
      // })

      // this.$firebaseRefs.users.child().set({
      //   name: this.userName,
      //   team: this.teamSelect
      // })